import { mediaQuery } from 'common/theme/media';
import styled, { css } from 'styled-components';

export const Mobile = css``;
export const Tablet = css`
    .page-head {
        margin-bottom: 50px;
    }
    .page-content {
        padding: 0;
    }
    .custom-table {
        thead {
            display: none;
        }
        tbody {
            tr {
                &:hover {
                    td {
                        background-color: transparent !important;
                    }
                }
                border-radius: 6px;
                display: flex;
                flex-direction: column;
                border: solid 1px #eee !important;
                padding: 10px !important;
                margin-bottom: 15px;
                td {
                    border: none !important;
                    padding: 2px 0 !important;
                }
            }
        }
    }
`;

export const Styled = styled.div`
    .page-head {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;
        gap: 10px;
        .title {
            font-weight: 600;
            font-size: 16px;
            color: #303641;
            flex: 1;
        }
    }
    .page-content {
        background-color: #fff;
        border-radius: 6px;
        padding: 30px;

        .custom-table {
            margin-top: -30px;
            border-collapse: separate;
            border-spacing: 0 16px;
            tbody {
                tr {
                    border-color: transparent;
                    .buttons {
                        display: flex;
                        flex-direction: row;
                        justify-content: end;
                        align-items: center;
                        gap: 10px;
                        button,
                        a {
                            background-color: #f8f9fc;
                            color: #646a76;
                            border-radius: 6px;
                            width: 30px;
                            height: 30px;
                            * {
                                font-size: 17px;
                            }
                        }
                    }
                    &:hover {
                        td {
                            background-color: #eeeeee;
                        }
                        .buttons {
                            button,
                            a {
                                background-color: var(--mui-palette-primary-main);
                                color: #fff;
                            }
                        }
                    }
                    td {
                        border-bottom: solid 1px #eee;
                        border-top: solid 1px #eee;
                        padding: 10px 16px;
                        &:first-child {
                            border-left: solid 1px #eee;
                            border-radius: 6px 0 0 6px;
                        }
                        &:last-child {
                            border-right: solid 1px #eee;
                            border-radius: 0 6px 6px 0;
                        }
                    }
                }
            }

            .no-data {
                border: none !important;
                user-select: none;
                pointer-events: none;
                .box {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    padding: 60px 30px;
                    font-size: 14px;
                    color: #303641;

                    .icon {
                        background-color: rgb(0 152 194 / 10%);
                        color: #0098c2;
                        width: 58px;
                        height: 58px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-radius: 6px;
                        margin-bottom: 15px;
                        * {
                            font-size: 32px;
                        }
                    }
                }
            }
        }
    }
    ${mediaQuery.lessThan('xltablet')`${Tablet}`}
    ${mediaQuery.lessThan('mobile')`${Mobile}`}
`;
